import { styled } from '@linaria/react';
import { useDisclosure } from '@mantine/hooks';
import { useQueryClient } from '@tanstack/react-query';
import { useState } from 'react';
import type { ProjectsResponse, Subproject } from '../../../../api/projects-client/projects-client.type';
import { useGlobalStore } from '../../../../store/global-store/global-store';
import { CreateProjectWizard } from './create-project-wizard';
import { EditProjectWizard } from './edit-project-wizard';
import { useProjectsByPortfolioId } from './project.hooks';
import { ProjectsList } from './projects-list';
import { ProjectPanel } from './projects-panel';

export function Projects() {
  const queryClient = useQueryClient();
  const selectedPortfolio = useGlobalStore((state) => state.portfolio);
  const [createProjectWizardOpened, toggleCreateProjectWizard] = useDisclosure(false);
  const [editProjectWizardOpened, toggleEditProjectWizard] = useDisclosure(false);
  const [selectedProject, setSelectedProject] = useState<ProjectsResponse | null>(null);
  const [selectedBoard, _setSelectedBoard] = useState<Subproject | null>(null);

  const { projects = [], query: projectsQuery } = useProjectsByPortfolioId({
    portfolioId: selectedPortfolio?.id || null,
    projectFields: ['id', 'name', 'subprojects', 'pm_tool'],
  });

  function handleSubmitCreateProject() {
    queryClient.invalidateQueries(projectsQuery);
    toggleCreateProjectWizard.close();
  }

  function handleSubmitEditProject() {
    queryClient.invalidateQueries(projectsQuery);
    toggleEditProjectWizard.close();
  }

  return (
    <Container>
      <ProjectsList
        projects={projects}
        selectedProject={selectedProject}
        setSelectedProject={setSelectedProject}
        onCreateProject={toggleCreateProjectWizard.open}
      />
      <ProjectPanel
        project={selectedProject}
        boards={selectedProject?.subprojects || []}
        selectedBoard={selectedBoard}
        isEditingProject={editProjectWizardOpened}
        setIsEditingProject={toggleEditProjectWizard.open}
      />
      <CreateProjectWizard
        projects={projects}
        opened={createProjectWizardOpened}
        onClose={toggleCreateProjectWizard.close}
        onSubmit={handleSubmitCreateProject}
      />
      <EditProjectWizard
        project={selectedProject}
        allProjects={projects}
        opened={editProjectWizardOpened}
        onClose={toggleEditProjectWizard.close}
        onSubmit={handleSubmitEditProject}
      />
    </Container>
  );
}

const Container = styled.div`
  display: flex;
  flex-direction: row;
  gap: 16px;
  width: 100%;
  margin: 16px 0px 0px 0px;
`;
